import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const BENEFITS = [
  { icon: "ri-search-line", title: "Product Research", desc: "Quickly scan products, prices and categories without opening endless tabs." },
  { icon: "ri-store-2-line", title: "Seller Research", desc: "Compare sellers side by side and keep track of who offers what." },
  { icon: "ri-truck-line", title: "Shipping Research", desc: "Check shipping costs, methods and delivery details before you buy." },
  { icon: "ri-star-line", title: "Reviews & Comparisons", desc: "See how products and sellers stack up at a glance." },
  { icon: "ri-shield-check-line", title: "Safety Resources", desc: "Learn how to verify links, sellers and payment details safely." },
  { icon: "ri-book-open-line", title: "Beginner Guides", desc: "Step-by-step help for anyone new to USFans research." },
];

const POPULAR = [
  "USFans Spreadsheet",
  "USFans Review",
  "USFans Shipping Cost",
  "USFans Coupon",
  "USFans Discount Code",
  "USFans Warehouse",
  "USFans Legit",
];

export default function InfoSections() {
  const { t } = useTranslation();
  const { lang } = useParams();

  return (
    <>
      {/* What is USFans Spreadsheet */}
      <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-5">
            {t("about.title")}
          </h2>
          <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-7">
            {t("about.body")}
          </p>
          <Link
            to={`/${lang}/article/usfans-spreadsheet-guide`}
            className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-secondary-500 text-background-50 font-semibold hover:bg-secondary-600 transition whitespace-nowrap"
          >
            {t("about.cta")}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </section>

      {/* Benefits */}
      <section className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
              {t("benefits.title")}
            </h2>
            <p className="text-foreground-600 max-w-2xl mx-auto">{t("benefits.subtitle")}</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {BENEFITS.map((b) => (
              <div
                key={b.title}
                className="rounded-lg border border-background-200 bg-background-50 p-6 hover:border-secondary-300 transition"
              >
                <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-900 mb-4">
                  <i className={`${b.icon} text-xl`}></i>
                </span>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2">
                  {b.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{b.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Popular searches */}
      <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            {t("popular.title")}
          </h2>
          <p className="text-foreground-600 mb-8">{t("popular.subtitle")}</p>
          <div className="flex flex-wrap justify-center gap-2">
            {POPULAR.map((p) => (
              <span
                key={p}
                className="px-4 py-2 rounded-full bg-background-50 border border-background-200 text-sm text-foreground-700 whitespace-nowrap"
              >
                {p}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* Safety */}
      <section className="w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-4xl mx-auto text-center">
          <span className="w-14 h-14 flex items-center justify-center rounded-full bg-accent-100 text-accent-900 mx-auto mb-5">
            <i className="ri-shield-star-line text-2xl"></i>
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-5">
            {t("safety.title")}
          </h2>
          <p className="text-base md:text-lg text-foreground-700 leading-relaxed mb-7">
            {t("safety.body")}
          </p>
          <Link
            to={`/${lang}/safety`}
            className="inline-flex items-center gap-2 h-11 px-6 rounded-md border border-primary-300 text-primary-700 font-semibold hover:bg-primary-100 transition whitespace-nowrap"
          >
            {t("safety.cta")}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </section>
    </>
  );
}